<div [class.pt-3]="isIos" [class.pt-5]="!isIos" class="container">
  <div (click)="back()" *ngIf="isIos" class="d-inline-flex align-items-center mb-3 cursor-pointer p-1">
    <span [inlineSVG]="'assets/img/chevron-left.svg'" class="svg-8 mr-3 d-flex"></span>
    <span>{{'back'|translate}}</span>
  </div>
  <div *ngIf="dataAvailable" class="row">

    <div class="col-lg-8 mb-3 mb-md-0">
      <div class="d-flex flex-lg-wrap position-relative">
        <div class="doctor-image">
          <img loading="lazy" (error)="updateUrl($event)" [src]="apiUrl+'/files/profile_pic/' + id + '?size=s'"
               alt="">
          <div class="d-flex justify-content-center">
          </div>
        </div>
        <div class="doctor-info">
          <button class="share-doctor" matRipple shareButton="facebook"
                  url="{{baseUrl}}/eqimi/{{getDoctorName()}}/{{id}}">
            <mat-icon>share</mat-icon>
            <span>{{'share' | translate}}</span>
          </button>
          <h1 class="name uppercase">{{doctorPublicProfile.doctorFullname}}</h1>
          <div *ngIf="doctorPublicProfile.country" class="country">
            {{doctorPublicProfile.country}} - {{doctorPublicProfile?.foreignDoctorClinic}}
          </div>
          <span *ngIf="doctorPublicProfile.clinic" class="clinic-name"><a
              (click)="goToClinicSearchResults()">{{doctorPublicProfile?.clinic?.name}}</a></span>
          <ng-container *ngIf="doctorPublicProfile.provider.length > 0">
            <div (click)="openInsuranceProvidersList(doctorPublicProfile.provider)"
                 class="insurance-provider cursor-pointer mb-3">
              {{'insurance-provider' | translate}}
            </div>
          </ng-container>
          <p *ngIf="doctorPublicProfile"></p>
          <div *ngFor="let speciality of doctorPublicProfile.doctorSpeciality" class="proffesion uppercase">
            {{speciality.doctorSpecialityName}}
          </div>
          <div class="d-flex align-items-center overal-reviews-container flex-wrap">
            <div class="overal-reviews d-flex">
              <app-rating-stars [rating]="doctorCriteriaRating.doctorRating"></app-rating-stars>
            </div>
            <span class="rating-score">{{doctorCriteriaRating.doctorRating.toPrecision(2)}}</span>
            <a (click)="scrollToReviews()" class="all-reviews text-nowrap">{{doctorCriteriaRating.reviewCount}}
              {{'review'|translate}}</a>
          </div>
          <!-- <div class="d-flex flex-wrap info-texts">
            <span class="muted">ხარისხი:</span>
            <span *ngFor="let education of doctorPublicProfile.doctorEducation" class="val font-weight-bold">
              {{education.doctorEducationLevelName}}
            </span>
          </div> -->
          <div class="d-flex flex-wrap info-texts mb-0">
            <span class="muted">{{'language'|translate}}:</span>
            <span *ngFor="let lang of doctorPublicProfile.doctorLanguage" class="mr-3">
              {{lang.doctorLanguageName}}
            </span>
          </div>
        </div>
      </div>
      <div class="booking-card responsive d-block d-lg-none" *ngIf="doctor">
        <h1 class="font-weight-bold uppercase">{{'consult-now'|translate}}</h1>
        <app-time-slot (onServiceTypeSelect)="onServiceTypeSelect($event)"
                       (onSpecialtyChange)="onSpecialityChange($event)"
                       (searchDateChange)="getDoctorTimeSlotsBySpecialty(specialtyId, $event)"
                       [doctor]="doctor"
                       [id]="id"
                       [isPublicProfile]="true"
                       [selectedServiceType]="selectedServiceType"
                       [selectedSpeciality]="specialtyId || doctorPublicProfile?.doctorSpeciality[0]?.doctorSpecialityId">
        </app-time-slot>
      </div>
      <!-- <div id="map" class="d-flex align-items-center justify-content-center"> this is map area</div> -->
      <!-- last reviews -->
      <div class="last-reviews">
        <div class="position-relative">
          <div class="d-flex flex-wrap">
            <div class="rating-block">
              <span class="d-block text-center score-title">{{'avgRating'|translate}}</span>
              <span class="score d-block text-center">{{doctorCriteriaRating.doctorRating.toPrecision(2)}}</span>
              <div class="overal-reviews-container">
                <div class="overal-reviews d-flex justify-content-center">
                  <app-rating-stars [rating]="doctorCriteriaRating.doctorRating"></app-rating-stars>
                </div>
                <a (click)="scrollToReviews()"
                   class="all-reviews d-block text-center">{{doctorCriteriaRating.reviewCount}}
                  {{'review'|translate}}</a>
              </div>
            </div>
            <div class="text-block">
              <h2 class="uppercase">{{'lastReviews'|translate}}</h2>
              <ng-container *ngFor="let comment of doctorComments, let i = index">
                <ng-container *ngIf="i < 2">
                  <p>
                    {{comment.comment}}
                    <span class="d-block mt-2"> {{comment.userName}}
                      - {{comment.reviewCreateDate | date: 'dd.MM.yyyy' : '' : selectedLanguage}}</span>
                  </p>
                </ng-container>

              </ng-container>
              <a (click)="scrollToReviews()"
                 class="d-flex view-all align-items-center cursor-pointer">{{'allReviews'|translate}}
                <span [inlineSVG]="'assets/img/long-arrow-right.svg'"
                      class="svg-16 d-flex ml-2"></span></a>
            </div>
          </div>
        </div>
      </div>
      <!-- about me -->
      <div *ngIf="doctorPublicProfile.doctorInfo" class="about-me">
        <div class="position-relative">
          <h2 class="uppercase">{{'aboutMe'|translate}}</h2>
          <p [innerHTML]="doctorPublicProfile.doctorInfo" style="white-space: pre-wrap;">
          </p>
          <div class="d-flex justify-content-between">
            <!-- <a (click)="scrollToReviews()" class="d-flex view-all align-items-center">ყველა განხილვა <span
                    [inlineSVG]="'assets/img/long-arrow-right.svg'" class="svg-16 d-flex ml-2"></span></a> -->
            <!--                        <a class="cv" routerLink="{{ cLang }}/main">CV-ის ნახვა</a>-->
          </div>
        </div>
      </div>

      <div class="diplomas">
        <div class="position-relative">
          <h2 class="uppercase">{{'myServices'|translate}}</h2>
          <div *ngFor="let services of doctorPublicProfile.doctorService"
               class="d-flex justify-content-between location-list border-top-0 pt-0">
            <div>
              <b class="font-weight-normal">
                {{services.doctorServiceName}}
              </b>
              <!--              <span class="spec d-block">{{services.price}}</span>-->
            </div>
            <a class="d-flex align-items-center show-on-map">
              <span class="text-body font-weight-normal mr-4">
                {{services.price}} ₾</span></a>
          </div>
        </div>
      </div>

      <div *ngIf="doctorPublicProfile.doctorEducation.length" class="diplomas">
        <div class="position-relative">
          <h2 class="uppercase">{{'myDiplomasAndCertificates'|translate}}</h2>
          <div *ngFor="let education of doctorPublicProfile.doctorEducation"
               class="d-flex justify-content-between location-list border-top-0 pt-0">
            <div>
              <b class="font-weight-normal">
                {{education.universityName}}
              </b>
              <span class="spec d-block">{{education.doctorEducationLevelName}}</span>
            </div>
            <a class="d-flex align-items-center show-on-map">
              <span class="text-body font-weight-normal mr-4">
                {{education.startMonth + '/' + education.startYear + ' - ' + education.endMonth + '/' + education.endYear}}
                წ.</span></a>
          </div>
        </div>
      </div>

      <div *ngIf="doctorPublicProfile.doctorWorkExperience.length" class="diplomas">
        <div class="position-relative">
          <h2 class="uppercase">{{'myWorkExperience'|translate}}</h2>
          <div class="overflow-auto">
            <div *ngFor="let experiance of doctorPublicProfile.doctorWorkExperience"
                 class="d-flex justify-content-between location-list border-top-0 pt-0">
              <div style="width: 33%; min-width: 150px;">
                <b class="font-weight-normal">
                  {{experiance.companyName}}
                </b>
                <span class="spec d-block">{{experiance.country}}</span>
              </div>
              <div style="width: 33%; min-width: 150px;">
                <b class="font-weight-normal">
                  {{experiance.position}}
                </b>
                <span class="spec d-block">{{experiance.specialityName}}</span>
              </div>
              <a class="d-flex align-items-center show-on-map justify-content-end"
                 style="width: 33%; min-width: 150px;"> <span
                  class="text-body font-weight-normal mr-4">{{experiance.startMonth + '/' + experiance.startYear + ' - ' + ((!experiance.endMonth || !experiance.endYear) ? ('current' | translate) : (experiance.endMonth + '/' + experiance.endYear + ' წ.'))}}
                </span></a>
            </div>
          </div>

        </div>
      </div>

      <!-- reviews -->
      <div #doctorReviews class="patient-reviews">
        <ng-container *ngIf="doctorComments.length">
          <h2 class="uppercase">{{'reviews'|translate}}</h2>
          <p class="info">{{'theseReviewsAreWrittenByPatients'|translate}}</p>
          <div class="overal-reviews-container">

            <div class="d-flex mb-2">
              <div class="overal-reviews d-flex mr-1 mr-md-5">
                <app-rating-stars [rating]="doctorCriteriaRating.averageSatisfaction"></app-rating-stars>
              </div>
              <div class="font-weight-bold"> {{'competent'|translate}}
                ({{doctorCriteriaRating.averageSatisfaction.toFixed(2)}})
              </div>
            </div>
            <div class="d-flex mb-2">
              <div class="overal-reviews d-flex mr-1 mr-md-5">
                <app-rating-stars [rating]="doctorCriteriaRating.averagePunctuality"></app-rating-stars>
              </div>
              <div class="font-weight-bold"> {{'punctual'|translate}}
                ({{doctorCriteriaRating.averagePunctuality.toFixed(2)}})
              </div>
            </div>
            <div class="d-flex mb-2">
              <div class="overal-reviews d-flex mr-1 mr-md-5">
                <app-rating-stars [rating]="doctorCriteriaRating.averageReliability"></app-rating-stars>
              </div>
              <div class="font-weight-bold"> {{'responsible'|translate}}
                ({{doctorCriteriaRating.averageReliability.toFixed(2)}})
              </div>
            </div>
            <a (click)="scrollToReviews()"
               class="all-reviews d-flex mt-3">{{doctorCriteriaRating.reviewCount}} {{'review'|translate}} <span
                [inlineSVG]="'assets/img/long-arrow-right.svg'" class="svg-16 d-flex ml-2"></span></a>
          </div>
          <ng-container *ngFor="let comment of doctorComments, let i = index">
            <ng-container *ngIf="(showMore ? i >= 0 : i < 3)">
              <div class="detail-reviews-container">
                <div class="d-flex flex-wrap">
                  <div class="overal-revies-container-border mb-3 mb-md-0">
                    <div class="font-weight-bold mb-2"> {{'responsible'|translate}}</div>
                    <div class="overal-reviews d-flex mr-5">
                      <app-rating-stars [rating]="comment.reliability"></app-rating-stars>
                    </div>
                  </div>
                  <div class="overal-revies-container-border mb-3 mb-md-0">
                    <div class="font-weight-bold mb-2"> {{'punctual'|translate}}</div>
                    <div class="overal-reviews d-flex mr-5">
                      <app-rating-stars [rating]="comment.punctuality"></app-rating-stars>
                    </div>
                  </div>
                  <div class="overal-revies-container-border mb-3 mb-md-0">
                    <div class="font-weight-bold mb-2"> {{'competent'|translate}}</div>
                    <div class="overal-reviews d-flex mr-5">
                      <app-rating-stars [rating]="comment.satisfaction"></app-rating-stars>
                    </div>
                  </div>
                </div>
              </div>
              <p>{{comment.comment || ''}}</p>
              <div class="author">- {{comment.userName}} - {{comment.reviewCreateDate | date: 'dd.MM.yyyy' : '' : selectedLanguage}}</div>
            </ng-container>
          </ng-container>

          <button (click)="showMore = !showMore" *ngIf="doctorComments.length > 3"
                  class="load-more">{{showMore ? ('less' | translate) : ('more' | translate)}} {{'review'|translate}}
          </button>
        </ng-container>
        <ng-container *ngIf="!doctorComments.length">
          <h2 class="uppercase">{{'reviews' | translate}}</h2>
          <p class="info">{{'doctorHasNoReviews'|translate}}</p>
        </ng-container>

      </div>
    </div>
    <div class="col-lg-4 d-none d-lg-block">
      <div class="booking-card" *ngIf="doctor">
        <h1 class="font-weight-bold uppercase">{{'consult-now'|translate}}</h1>
        <app-time-slot (onServiceTypeSelect)="onServiceTypeSelect($event)"
                       (onSpecialtyChange)="onSpecialityChange($event)"
                       (searchDateChange)="getDoctorTimeSlotsBySpecialty(specialtyId, $event)"
                       [doctor]="doctor"
                       [id]="id"
                       [isPublicProfile]="true"
                       [selectedServiceType]="selectedServiceType"
                       [selectedSpeciality]="specialtyId || doctorPublicProfile?.doctorSpeciality[0]?.doctorSpecialityId">
        </app-time-slot>
      </div>
    </div>
  </div>
</div>